module.exports = __webpack_public_path__ + "img/box-04.7626ba0b.jpg";